import { render, staticRenderFns } from "./ReceptionCard.vue?vue&type=template&id=c5371f16&"
import script from "./ReceptionCard.vue?vue&type=script&lang=ts&"
export * from "./ReceptionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports